<div class="modal-header">
    <h4 class="modal-title"></h4>
    <button
        type="button"
        class="btn-close btn-close-white"
        aria-label="Close"
        (click)="close()"
    ></button>
</div>
<div class="modal-body">
    <div class="contentContainer">
        <div class="title">{{ "modales.diploma.title" | translate }}</div>
        <img [src]="getDiplomaPath()" draggable="false" />
        <div class="buttonsContainer">
            <div (click)="close()" class="closeButton button">
                {{ "modales.diploma.close" | translate }}
            </div>
            <div (click)="download()" class="downloadButton button">
                {{ "modales.diploma.download" | translate }}
            </div>
        </div>
    </div>
</div>
